import styled from "styled-components";

export const Container = styled.div`
  font-size: 4.3vh;
  height: 12%;
  display: flex;
  align-items: center;
  justify-content: center;

  animation: ${(props) =>
    props.isNewComponent ? "fadein 0.5s" : "fadeout 0.5s"};

  @keyframes fadeout {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Firefox < 16 */
  @-moz-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Safari, Chrome and Opera > 12.1 */
  @-webkit-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Internet Explorer */
  @-ms-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* Opera < 12.1 */
  @-o-keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const Link = styled.span`
  color: #5776ff;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
`;
